import { FileText } from 'lucide-react'

export function DocumentEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <FileText className="size-8 text-muted-foreground mb-2" />
      <h3 className="text-sm font-semibold text-foreground mb-1">No documents</h3>
      <p className="text-xs text-muted-foreground max-w-sm">
        Upload files or import from the data lake to see them here.
      </p>
    </div>
  )
}
